<template>
  <div>
    <b-tabs v-model="companyTab" align="center">
      <b-tab>
        <template #title>
          <feather-icon icon="LayersIcon" />
          <span style="font-size: 13px">FEDEX</span>
        </template>

        <fedex />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import CopyToClipboard from "vue-copy-to-clipboard";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BProgress,
  BModal,
  BCardText,
  BTabs,
  BTab,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import useJwt from "@/auth/jwt/useJwt";
import axios from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import fedex from "./fedex.vue";
import { stateOptions } from "@/utils/states.js";
export default {
  components: {
    BCardCode,
    BTable,
    BProgress,
    BBadge,
    BButton,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BCardText,
    BTabs,
    BTab,
    flatPickr,
    BFormCheckbox,
    BFormRadio,
    CopyToClipboard,
    fedex,
    stateOptions,
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss">
/*  */
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.input-group {
  box-shadow: none !important;
}
</style>
